import React from 'react';
import { Field } from 'react-form';
import InfoButton from '../../InfoButton';

import styles from './Select.scss';

const UncontrolledSelect = (props) => {
    return (
        <Field field={props.field} validate={props.validate} options={props.options}>
            { fieldApi => {
                const {
                    onChange,
                    onBlur,
                    field,
                    validate,
                    id,
                    label,
                    formGroupCssClass,
                    hiddenLabel,
                    hiddenDefault,
                    description,
                    emptyOption,
                    options,
                    optionsAsPrimitiveArray,
                    hoverText,
                    attributeToSave,
                    attributeToShow,
                    themeV3,
                    'data-testid': dataTestId,
                    ...rest
                } = props;

                const { value, error, warning, /* success, */ touched, setValue, setTouched } = fieldApi;

                const inputProps = {
                    ...rest,
                    id,
                    className: `form-control ${styles.formControl}`,
                    value: value || '',
                    onChange: e => {
                        setTouched();
                        // setValue(e.target.value);
                        setValue(e.target.value);
                        if (onChange) {
                            onChange(e.target.value, e);
                        }
                    },
                    onBlur: e => {
                        setTouched();
                        if (onBlur) {
                            onBlur(e);
                        }
                    },
                };

                if (hiddenDefault && !value && options.length > 0) {
                    setValue((attributeToSave && options[0][attributeToSave]) ? options[0][attributeToSave] : options[0].id);
                }
                return (
                    <div className={`form-group form-group-xl ${styles.formSelect} ${formGroupCssClass} ${(touched && error) && `${styles.isInvalid} is-invalid`} ${description && 'description'} ${themeV3 ? styles.themeV3 : ''}`} data-testid={dataTestId || undefined}>
                        <label htmlFor={id} className={hiddenLabel ? 'sr-only' : ''}>
                            {!themeV3 && label}
                            {hoverText && <InfoButton hoverText={hoverText} />}
                        </label>
                        {description && (<small>{description}</small>)}
                        <div className="input-wrapper">
                            <select {...inputProps} data-testid={dataTestId && `${dataTestId}.select`}>
                                {hiddenDefault ? null : <option value="">{emptyOption}</option>}
                                {!optionsAsPrimitiveArray ? options?.map(option => <option value={(attributeToSave && option[attributeToSave]) ? option[attributeToSave] : option.id} key={option.id} disabled={!!option.disabled}>{(attributeToShow && option[attributeToShow]) ? option[attributeToShow] : option.label}</option>)
                                    : options?.map(val => <option value={val} key={val}>{val}</option>)}
                            </select>
                            {!themeV3 && <div className="error-indicator" />}
                            {themeV3 && <label>{label}</label>}
                        </div>
                        {touched &&
                            ((error && <div className="invalid-feedback" data-testid={dataTestId && `${dataTestId}.error`}>{error}</div>) ||
                            (warning && <div className="warning-feedback" data-testid={dataTestId && `${dataTestId}.warning`}>{warning}</div>))}
                    </div>
                );
            }}
        </Field>
    );
};

const ControlledSelect = (props) => {
    const {
        id,
        label,
        formGroupCssClass,
        hiddenLabel,
        hiddenDefault,
        description,
        emptyOption,
        options,
        optionsAsPrimitiveArray,
        hoverText,
        attributeToSave,
        attributeToShow,
        onChange,
        themeV3,
        'data-testid': dataTestId,
        ...rest
    } = props;

    const inputProps = {
        ...rest,
        id,
        className: 'form-control',
    };

    return (
        <div className={`form-group form-group-xl ${styles.formSelect} ${formGroupCssClass} ${description && 'description'} ${themeV3 ? styles.themeV3 : ''}`} data-testid={dataTestId || undefined}>
            <label htmlFor={id} className={hiddenLabel ? 'sr-only' : ''}>
                {!themeV3 && label}
                {hoverText && <InfoButton hoverText={hoverText} />}
            </label>
            {description && (<small>{description}</small>)}
            <div className="input-wrapper">
                <select onChange={onChange ? (e) => onChange(e.target.value) : null} {...inputProps} data-testid={dataTestId && `${dataTestId}.select`}>
                    {hiddenDefault ? null : <option value="">{emptyOption}</option>}
                    {!optionsAsPrimitiveArray ? options?.map(option => <option value={(attributeToSave && option[attributeToSave]) ? option[attributeToSave] : option.id} key={option.id} disabled={!!option.disabled}>{(attributeToShow && option[attributeToShow]) ? option[attributeToShow] : option.label}</option>)
                        : options?.map(val => <option value={val} key={val}>{val}</option>)}
                </select>
                <div className="error-indicator" />
                <label>{themeV3 && label}</label>
            </div>
        </div>
    );
};

const Select = ({ controlled, ...restProps }) => {
    if (controlled) {
        return <ControlledSelect {...restProps} />;
    }
    return <UncontrolledSelect {...restProps} />;
};

Select.defaultProps = {
    controlled: false,
};

export default Select;
